import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from '../store/authSlice';
import { API_CONFIG } from '../config/apiConfig';

const baseQuery = fetchBaseQuery({
    baseUrl: API_CONFIG.baseUrl,
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token || localStorage.getItem('token');
        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        // Always set ngrok skip header and accept json
        headers.set('Accept', 'application/json');
        return headers;
    },
});

export const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    // Handle 401 Unauthorized or specific error message
    if (result.error) {
        const isLoginAttempt = api.endpoint === 'login';
        const status = result.error.status;
        const data = result.error.data;

        const getErrorString = (val) => {
            if (!val) return '';
            return typeof val === 'string' ? val : JSON.stringify(val);
        };

        // Extract error message for logging
        const errorMessage = getErrorString(data?.message || data?.error);

        // Only logout and redirect if NOT a login attempt and it's an auth failure
        // Skip redirection if we are on the onboarding page or it's an onboarding related request
        const isOnboardingPage = typeof window !== 'undefined' && window.location.pathname.toLowerCase().includes('/my-team/onboarding');
        const isOnboardingEndpoint = args?.url?.includes('/employees/verify-document-token/') || args?.url?.includes('/onboarding/portal/');

        if (!isLoginAttempt && (status === 401 || (data?.success === false && (errorMessage.toLowerCase().includes('token'))))) {
            if (!isOnboardingPage && !isOnboardingEndpoint) {
                console.error('Authentication required or token invalid - Logging out');
                api.dispatch(logout());

                if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
                    window.location.href = '/login';
                }
            }
        }
    } else if (result.data?.success === false) {
        const getErrorString = (val) => {
            if (!val) return '';
            return typeof val === 'string' ? val : JSON.stringify(val);
        };
        const errStr = getErrorString(result.data?.error);
        const msgStr = getErrorString(result.data?.message);
        if (errStr.toLowerCase().includes('token') || msgStr.toLowerCase().includes('token')) {
            // Only trigger logout if NOT a login attempt (though usually success: false with 200 is from other APIs)
            const isOnboardingPage = typeof window !== 'undefined' && window.location.pathname.toLowerCase().includes('/my-team/onboarding');
            const isOnboardingEndpoint = args?.url?.includes('/employees/verify-document-token/') || args?.url?.includes('/onboarding/portal/');

            if (api.endpoint !== 'login' && !isOnboardingPage && !isOnboardingEndpoint) {
                console.error('Token invalid in response body - Logging out');
                api.dispatch(logout());
                if (typeof window !== 'undefined' && !window.location.pathname.includes('/login')) {
                    window.location.href = '/login';
                }
            }
        }
    }

    return result;
};
